const PersonIcon = () => {
  return (
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.79063 7.97033C9.55359 7.97033 10.9952 6.53738 10.9952 4.77442C10.9952 3.01146 9.56228 1.56982 7.79063 1.56982C6.02767 1.56982 4.59473 3.00277 4.59473 4.77442C4.59473 6.54606 6.02767 7.97033 7.79063 7.97033Z" fill="#1D1D1F"/>
<path d="M10.2916 9.21167H5.71489C3.66534 9.21167 2.00659 10.8791 2.00659 12.92V13.5105C2.00659 14.3442 2.69267 15.0303 3.52638 15.0303H12.4801C13.3139 15.0303 13.9999 14.3442 13.9999 13.5105V12.9286C13.9999 10.8791 12.3325 9.21167 10.2916 9.21167Z" fill="#1D1D1F"/>
</svg>
  )
}

export default PersonIcon